<template>
  <div class="dashboard-container">
    <div class="app-container">目录添加</div>
  </div>
</template>

<script>
export default {
  name: 'DirectorysAdd',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>
